import { useService } from '@core/inversify-react';
import { EventBusType, IEventBus } from '../intefaces';

export const useBus = () => {
  return useService<IEventBus>(EventBusType);
};
